/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Copy_Code_ButtonInputs */



/**
* | output |
* | --- |
* | "Copy code" |
*
* @param {Team_Share_Copy_Code_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_copy_code_button = /** @type {((inputs?: Team_Share_Copy_Code_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Copy_Code_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "de") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "it") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "es") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Copy code")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Copy code")
	return /** @type {LocalizedString} */ ("Copy code")
});